module.exports = __webpack_public_path__ + "static/media/tip2.a7878961.svg";